import { Route } from '@angular/router';
import { UserSettingsResolver } from "../../../../../../../account/routing/resolvers/user-settings.resolver";
import {
    CurrenciesResolver,
    PaymentMethodsResolver,

    UnitsResolver
} from "../../../../../../../common/routing/resolvers";
import { ContractDashboardComponent } from '../../../../../../layouts/contract-dashboard';
import {
    TenderContractBidsAnalysisComponent,
    TenderContractDashboardSupplierAwardedComponent,
    TenderContractDashboardSupplierComponent
} from '../../../../../../pages';
import {
    TenderBidsTableViewComponent
} from "../../../../../../pages/tender-bids-table-view/tender-bids-table-view.component";
import { TenderContractDashboardComponent } from '../../../../../../pages/tender-contract-dashboard';
import { SealedTenderGuard } from '../../../../../guards/sealed-tender.guard';
import {
    TenderAnalyticsConversionFactor2Resolver,
    TenderUnitRatesResolver,
    TenderBidHistoryResolver,
    TenderContractDashboardResolver,
    TenderContractRoundResolver,
    TenderContractRoundSupplierResolver,
    TenderContractSuppliersResolver,
    TenderCoverLetterOfferDetailResolver,
    TenderDocumentsOfferDetailResolver
} from '../../../../../resolvers';
import { indexAnalysisRoute } from './index-analysis/index-analysis';

export const contractDashboardRoute: Route = {
    path: 'dashboard',
    component: ContractDashboardComponent,
    // Sealed tenders lock Dashboard, Vertical Analysis and Index Analytics while any round is
    // still open -- the server now answers 403 on the endpoints behind them
    // (buyer/views/sealed_screen_lock.py), so the browser has to refuse the navigation rather
    // than render a page that cannot load. On the parent, so every child inherits it: the
    // per-round dashboard and the per-supplier bid detail underneath it are the same data.
    canActivate: [SealedTenderGuard],
    resolve: {
        suppliers: TenderContractSuppliersResolver,
        contract: TenderContractDashboardResolver,
        rounds: TenderContractRoundResolver,
        currencies: CurrenciesResolver,
        units: UnitsResolver
    },
    runGuardsAndResolvers: 'always',
    children: [
        {
            path: 'round/:rid',
            component: TenderContractDashboardComponent,
        },
        {
            path: 'rounds/:rid/suppliers/:id',
            component: TenderContractDashboardSupplierComponent,
            resolve: {
                supplier: TenderContractRoundSupplierResolver,
                coverLetter: TenderCoverLetterOfferDetailResolver,
                documents: TenderDocumentsOfferDetailResolver,
                bidHistory: TenderBidHistoryResolver,
                tenderSettings: TenderAnalyticsConversionFactor2Resolver,
                unitRates: TenderUnitRatesResolver
            },
        },
        {
            path: 'rounds/:rid/suppliers/:id/awarded',
            component: TenderContractDashboardSupplierAwardedComponent,
            resolve: {
                supplier: TenderContractRoundSupplierResolver,
                coverLetter: TenderCoverLetterOfferDetailResolver,
                documents: TenderDocumentsOfferDetailResolver,
                bidHistory: TenderBidHistoryResolver
            },
        },
        {
            path: 'analysis/round/:rid',
            component: TenderContractBidsAnalysisComponent,
            canActivate: [SealedTenderGuard],
            resolve: {
                //inputCurrentOffers: TenderAnalyticsLocationInputCurrentContractResolver,
                paymentMethods: PaymentMethodsResolver,
                tenderSettings: TenderAnalyticsConversionFactor2Resolver,
                unitRates: TenderUnitRatesResolver,
                userSettings: UserSettingsResolver,
            },
        },
        {
            path: 'offers/table',
            component: TenderBidsTableViewComponent,
            canActivate: [SealedTenderGuard],
            resolve: {
                tenderSettings: TenderAnalyticsConversionFactor2Resolver,
            },
        },
        indexAnalysisRoute,
    ]
};
